/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Account_FallbackInputs */

const en_profile_account_fallback = /** @type {(inputs: Profile_Account_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const pt_br2_profile_account_fallback = /** @type {(inputs: Profile_Account_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {Profile_Account_FallbackInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const profile_account_fallback = /** @type {((inputs?: Profile_Account_FallbackInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Account_FallbackInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_account_fallback(inputs)
	return pt_br2_profile_account_fallback(inputs)
});